import { PRODUCT_URL, PRODUCT_APP_ID, PRODUCT_APP_SECRET, authToken } from '../env'
import axios from '../_client'
import { EventBus } from '@/event-bus'
const posProductAxiosInstanceV1 = axios.create({
    baseURL: `${PRODUCT_URL}/api/v1`,
    headers: {
        'app-id': PRODUCT_APP_ID,
        'app-secret': PRODUCT_APP_SECRET
    }
})
posProductAxiosInstanceV1.interceptors.response.use(function (response) {
    if (response.data.redirect_to) {
        location.href = response.data.redirect_to
    }
    return response
}, function (error) {
    if (error.response.status === 401 || error.response.status === 403) {
        EventBus.$emit('unauthorized')
    }
    if (error.response.status !== 404) {
        EventBus.$emit('show-error-modal', error)
    }
    return Promise.reject(error)
})
export const PosProductAPI = {
    /**
     * Fetch data
     */
    fetch(locationUUID) {
        return posProductAxiosInstanceV1({
            method: 'get',
            url: `/locationPosProduct/${locationUUID}`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    importPos(locationUUID, params) {
        return posProductAxiosInstanceV1({
            method: 'post',
            url: `/locationPosProduct/import`,
            headers: {
                'auth-token': authToken()
            },
            data: {
                location_id: locationUUID
            },
            params: params
        })
    },

    syncPosPriceAndQty(locationUUID) {
        return posProductAxiosInstanceV1({
            method: 'post',
            url: `/locationPosProduct/updateProducts`,
            data: {
                location_id: locationUUID
            },
            headers: {
                'auth-token': authToken()
            }
        })
    }
}
